<style lang="scss" scoped>
.tile {
	text-align: center;
	cursor: pointer;
	position: relative;
	&.\--pending {
		&:before {
			content: "Pending Approval";
			margin: auto;
			display: block;
			top: 0;
			left: 0;
			width: 150px;
			color: white;
			background: #307fe2;
			padding: 4px;
			font-weight: 500;
			margin-bottom: -32px;
			z-index: 2;
			position: relative;
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}
	}
	&.\--declined {
		&:before {
			content: "Declined";
			background: #202020;
			margin: auto;
			display: block;
			top: 0;
			left: 0;
			width: 150px;
			color: white;
			padding: 4px;
			font-weight: 500;
			margin-bottom: -32px;
			z-index: 2;
			position: relative;
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}
	}
	&__icon {
		height: auto;
	}
	i {
		display: none;
		z-index: 3;
		margin-right: 2px;
	}
	&:hover {
		.tile__item__launchbox {
			display: block;
		}
	}
	&__item {
		display: inline-block;
		text-align: center;
		cursor: pointer;
		&__launchbox {
			position: absolute;
			top: 0;
			left: 0;
			height: 170px;
			width: 100%;
			padding: 25px;
			padding-top: 32px;
			background: #edeff07a;
			display: none;
		}
	}
	&__heading {
		margin-top: 15px;
		margin-top: 15px;
		margin-left: auto;
		margin-right: auto;
		text-overflow: ellipsis;
		text-align: center;
		width: 12ch;
		overflow: hidden;
		height: 70px;
		line-height: 23px;
	}
	.image-container {
		height: 150px;
		border-radius: 10px;
		background: white;
	}
}
</style>

<template lang="pug">
    .tile(:class="{ '--pending' : isPending, '--declined' : isDeclined }")
        .tile__item__launchbox(v-if="showLaunch")
            el-button.d-block.w-100.m-0.mb-2(@click='launchApp') Launch
            el-button.d-block.w-100.m-0(@click='openSettings') Settings
        .hitbox(@click='openSettings')
            .image-container
                IconImage(:icon="app.Icon", :size="150").tile__icon
            h3.tile__heading {{ app.application_name || app.name }}
</template>

<script>
import gql from "graphql-tag";
import tracker from "@/utils/event-tracker";
import { isAdminApp, isSingleSignOn } from "@/utils/admin-apps";
import IconImage from "@/components/ui/IconImage";

export default {
	components: {
		IconImage,
	},
	props: {
		app: {
			required: true,
			type: Object,
		},
		user: {
			required: true,
			type: Object,
		},
	},
	computed: {
		showLaunch() {
			if (!this.Company) return false;

			return isAdminApp(this.Company.slug) && this.Company.State.approved;
		},
		showStatus() {
			return this.app.CompanyTypes.sync || false;
		},
		isPending() {
			if (!this.showStatus || !this.Company) return false;

			return !this.Company.State.approved && !this.Company.State.declined;
		},
		isDeclined() {
			if (!this.showStatus || !this.Company) return false;

			return !this.Company.State.approved && this.Company.State.declined;
		},
	},
	apollo: {
		Company: {
			query: gql`
				query Company($id: String!) {
					CompanyById(id: $id) {
						id
						application_name
						slug
						name
						redirect
						client_id
						application_homepage
						State {
							approved
							declined
						}
					}
				}
			`,
			update: (d) => d.CompanyById,
			variables() {
				return {
					id: this.app.id,
				};
			},
			skip() {
				return !this.showStatus;
			},
		},
	},
	methods: {
		openSettings() {
			if (this.app.CompanyTypes.tile) {
				return this.$router.push({ name: "settings.tile", params: { tileId: this.app.id } });
			}

			if (this.app.CompanyTypes.sync) {
				return this.$router.push({ name: "settings.company", params: { company: this.app.id } });
			}

			return this.$router.push({ name: "settings.company", params: { company: this.app.id } });
		},
		launchApp() {
			if (this.app.CompanyTypes.tile) {
				tracker("launch-custom-tile", {
					tile_id: this.app.id,
					tile_name: this.app.name,
				});
			} else {
				tracker("launch-app", {
					application_id: this.app.id,
					application_name: this.app.name,
				});
			}

			if (isSingleSignOn(this.Company.slug)) {
				return this.$router.push({ name: "settings" });
			}

			if (isAdminApp(this.Company.slug)) {
				// If it's a single sign on, then go go go
				const routeData = this.$router.resolve({
					name: "authorize",
					query: {
						redirect_uri: this.Company.redirect,
						client_id: this.Company.client_id,
					},
				});

				return window.open(routeData.href, "_blank");
			}

			window.open(this.Company.application_homepage);
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/admin/Tile.vue